import { render, staticRenderFns } from "./userAccount.vue?vue&type=template&id=410d488e&scoped=true&"
import script from "./userAccount.vue?vue&type=script&lang=js&"
export * from "./userAccount.vue?vue&type=script&lang=js&"
import style0 from "./userAccount.vue?vue&type=style&index=0&id=410d488e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d488e",
  null
  
)

export default component.exports